export const config = {
	appName: process.env.REACT_APP_NAME,
	appEmail: process.env.REACT_APP_EMAIL,
	appPhone: process.env.REACT_APP_PHONE,
	appAddress: process.env.REACT_APP_ADDRESS,
};